import { Component, component, property } from '../../../../concepts/objects';
import { Matrix } from '../../../../platform/geom/Matrix';
import { Point } from '../../../../platform/geom/Point';
import { Rect } from '../../../../platform/geom/Rect';
import { AutoLayoutMode } from '../../autoLayout/AutoLayout';
import { Frame } from '../Frame';
import { FrameAddon } from '../FrameAddon';
import { DimensionsType } from './DimensionsType';
import { FrameAddonWithDimensions } from './FrameAddonWithDimensions';
import { GridFrameAddonPropertyLayout } from './GridFrameAddonPropertyLayout';

export const CalendarFrameAddonLayout = (object: GridFrameAddon) => {
    const { base } = object.parentFrame.layout;
    const [columns, rows] = object.dimensions;

    const pw = base.width / columns;
    const ph = base.height / rows;

    const pattern = {
        width: base.width / columns,
        height: base.height / rows,
        x: pw * .5,
        y: ph * .5,
    };

    return { base, pattern };
};

const gridFrameAddonDef = {
    name: 'GridFrameAddon',
    implements: [FrameAddon, FrameAddonWithDimensions],
    propertyLayout: GridFrameAddonPropertyLayout,
};

@component(gridFrameAddonDef)
export class GridFrameAddon extends Component implements FrameAddon, FrameAddonWithDimensions {

    public get parentFrame() {
        return this.parent?.as(Frame);
    }

    public get layout() {
        return CalendarFrameAddonLayout(this);
    }

    @property({ type: 'string', default: 'bottom' })
    public layer: 'bottom' | 'top';

    @property({ type: DimensionsType, default: [5, 5] })
    public dimensions: [number, number];

    @property({ type: 'string[]', default: AutoLayoutMode.none })
    public layoutMode: AutoLayoutMode;

    public layoutCells(mt: Matrix) {
        const cells = [] as Rect[];
        const [cols, rows] = this.dimensions;
        const { w, h } = this.parentFrame.size().divide([cols, rows]);

        for (let c = 0; c < cols; c++) {
            for (let r = 0; r < rows; r++) {
                cells.push(Rect.fromPoints(mt.apply(new Rect(w * c, h * r, w, h))));
            }
        }

        return cells;
    }

    public getCorrectedSize(w: number, h: number): Point {
        const [cols, rows] = this.dimensions;
        const dx = cols * 10;
        const dy = rows * 10;
        return new Point(
            Math.round(w / dx) * dx,
            Math.round(h / dy) * dy,
        );
    }

    public offsetDimensions(cc: number, rc: number): void {
        // Do nothing
    }
}
